import React from 'react';
import { AlertCircle, FileCheck2, Info } from 'lucide-react';
import { CANONICAL_REVIEW_NOTE } from '../constants';

interface ReviewNoticeProps {
  customContext?: string;
  variant?: 'banner' | 'card' | 'inline';
  topic?: string;
}

export default function ReviewNotice({ 
  customContext, 
  variant = 'card',
  topic 
}: ReviewNoticeProps) {
  if (variant === 'inline') {
    return (
      <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-amber-500/10 border border-amber-500/30 text-amber-300 text-xs">
        <Info className="w-3.5 h-3.5 flex-shrink-0" />
        <span>Verification / Expert Review in Progress</span>
      </div>
    );
  }

  if (variant === 'banner') {
    return (
      <div className="w-full bg-gradient-to-r from-amber-950/80 via-slate-900 to-amber-950/80 border-y border-amber-500/30 py-3 px-4 sm:px-6 text-xs text-amber-200">
        <div className="max-w-7xl mx-auto flex items-start gap-3">
          <AlertCircle className="w-4 h-4 text-amber-400 mt-0.5 flex-shrink-0" />
          <div>
            <span className="font-semibold text-amber-300 mr-1.5">Review Note — Verification in Progress:</span>
            {customContext || CANONICAL_REVIEW_NOTE}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 sm:p-5 rounded-2xl bg-amber-950/30 border border-amber-500/30 text-amber-200 text-xs sm:text-sm leading-relaxed backdrop-blur-sm">
      <div className="flex items-start gap-3">
        <FileCheck2 className="w-5 h-5 text-amber-400 mt-0.5 flex-shrink-0" />
        <div className="space-y-1.5">
          <div className="flex flex-wrap items-center gap-2">
            <span className="font-bold text-amber-300 text-xs uppercase tracking-wider">
              Review Note — Verification in Progress
            </span>
            {topic && (
              <span className="px-2 py-0.5 rounded-full bg-amber-500/20 text-amber-300 text-[10px] font-mono">
                {topic}
              </span>
            )}
          </div>
          <p className="text-amber-200/90 text-xs sm:text-sm leading-relaxed">
            {customContext || CANONICAL_REVIEW_NOTE}
          </p>
        </div>
      </div>
    </div>
  );
}
